// extracted by mini-css-extract-plugin
module.exports = {"dsaText":"DSADisplay_dsaText__Ocuxl"};